import { useConferenceDates } from '@/context/ConferenceConfigContext.jsx';
import { HtmlContent } from '@components/ui/HtmlContent.jsx';

export function HybridBanner() {
  const { hybridNote } = useConferenceDates();
  return (
    <section className="relative bg-gradient-to-r from-ink-950 via-brand-900 to-ink-950 text-white py-4 border-y border-bangkok-gold/20">
      <div className="container">
        <HtmlContent
          html={hybridNote}
          className="text-center text-sm sm:text-base font-semibold text-pretty text-white [&_a]:text-bangkok-gold [&_a]:underline"
        />
      </div>
    </section>
  );
}
